<!--
@Author: Calvin Green <calvin>
@Date:   2022-01-11T13:51:01+02:00
@Email:  calvin@diversitude.com
@Last modified by:   calvin
@Last modified time: 2022-02-01T10:43:40+02:00
@Copyright: Diversitude 2021
-->



<template>
    <Layout>
        <b-row>
            <b-col cols="2"  sm="3">
                <keep-alive>
                    <Menu @back="handleBack"/>
                </keep-alive>
            </b-col>
            <b-col cols="10"  sm="9">
                <Administration/>
            </b-col>
        </b-row>
    </Layout>
</template>

<script>
import Menu from '@/components/widgets/green-menu.vue'
import Layout from "../../layouts/main-stripped";
import Administration from '@/components/admin/administration/administration.vue'
import {layoutMethods} from '@/state/helpers';
export default {
    data:() => ({
        isEditing: false,
        isEditingClient: false,
        isNewDocument: false,
        hideMenu: false,

        showStats: false,
        showDistribution: false,
    }),
    components:{
        Layout,
        Menu,
        Administration,
    },
    computed: {
        
    },
    methods: {
        ...layoutMethods,
        handleBack(){
            this.showDocumentsMenu();
            this.isEditing = false;
            this.isEditingClient = false;
            this.showStats = false;
            this.showDistribution = false;
        },
        showDocumentsMenu(){
            this.updateMenuType({
                type: 'documents',
                showMenu: true,
                showRoutes: false,
            })
        },
        showEditMenu(){
            this.hideMenu = false;
            this.updateMenuType({
                type: 'document_edit',
                showMenu: false,
                showRoutes: false,
            })
        },
    },
    mounted(){
        this.$nextTick(()=>{
            this.updateMenuType({
                type: 'ccb_administration',
                showMenu: true,
                showRoutes: false,
            })
        })
    },
    beforeDestroy(){
        this.updateMenuType({
            type: 'Nothing',
            showMenu: true,
            showRoutes: false,
        })
    },
}
</script>

<style>

</style>
